import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import ProfileScreen from '../../Mars/Profile/ProfileScreen/Profile'

import * as tutorialActions from '../tutorial.actions'
import * as tutorialSelectors from '../tutorial.selectors'

const mapStateToProps = (state) => ({
  battles: tutorialSelectors.getProfileBattles(state),
  userData: tutorialSelectors.getCurrentUser(state),
  groupData: tutorialSelectors.getGroupData(state),
  players: Object.values(tutorialSelectors.getPlayerList(state)),
  rankingObfuscated: null,
})

const mapDispatchToProps = (dispatch) => ({
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProfileScreen))
